import { useState } from "react";

const originControl = () => {
    const [origin, setOrigin] = useState('');
    const [persistentParameters, setPersistentParametersState] = useState("");

    const origens = {
        listagem_carteira: "cadastro-e-credito",
        conversao_prospect: "conversao-prospect",
        cadastro_emissor: "cadastro-emissor",
        cadastro_recebedor: "cadastro-recebedor",
        edicao_recebedor: "edicao-recebedor",
        busca_online: "busca-online",
        solicitar_credito: "solicitar-credito",
        editar_pesquisa: "editar-pesquisa",

        //FUNIL
        acompanhamento_mapeamento: "acompanhamento-mapeamento",
        mapeamento: "mapeamento",
    }

    const parameters = {
        parametros_persistentes: "pp"
    }

    const getOrigem = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const origem = urlParams.get('origem');

        setOrigin(origem);

        return origem;
    }

    async function getPersistentParameters(){
        const urlParams = new URLSearchParams(window.location.search);
        let pp = urlParams.get(parameters.parametros_persistentes);
        pp = pp ? pp.split(',') : "";
        setPersistentParameters(pp);
        return pp;
    }

    async function setPersistentParameters(value){
        setPersistentParametersState(value)
    }

    return {
        getOrigem,
        origin,
        origens,
        parameters,
        persistentParameters,
        setPersistentParameters,
        getPersistentParameters
    }
  };

  export default originControl;
